"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndustryListRootsResponseSchema = exports.IndustryListRootsResultSchema = exports.IndustryListChildrenResponseSchema = exports.IndustryListChildrenSchema = void 0;
const zod_1 = require("zod");
const schemas_1 = require("../../../../schemas");
exports.IndustryListChildrenSchema = zod_1.z.object({ industries: schemas_1.LeafWithChainNodeSchema.array() });
exports.IndustryListChildrenResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.IndustryListChildrenSchema);
exports.IndustryListRootsResultSchema = zod_1.z.object({ industries: schemas_1.LeafWithChainNodeSchema.array() });
exports.IndustryListRootsResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.IndustryListRootsResultSchema);
